export default function SciPy_Certificate() {
  return (
    <div>
      <h1>SciPy Certificate</h1>
    </div>
  );
}
